// extracted by mini-css-extract-plugin
export default {"postList":"style_postList__JGZwL","title":"style_title__EjU+g","inputHighlighter":"style_inputHighlighter__8p3fJ"};